import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { currencyActions } from "../../../redux/actions/guides";
import { SimpleModal, MyInput, MyCheckBox, DialogModal } from "../../../components";
import * as Yup from "yup";
import DeleteIcon from '@material-ui/icons/Delete';
import { Button } from "@material-ui/core";
import useToggle from "../../../hooks/useToggle";
import { useStateIfMounted } from "use-state-if-mounted";

const defaultValues = {
  nameCurrency: "",
  fullNameCurrency: "",
  digitalCurrency: "",
  symbolCurrency: "",
  mainCurrency: false,
};

const validationSchema = Yup.object().shape({
  nameCurrency: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").required("Обязательное для заполнения поле"),
  fullNameCurrency: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").required("Обязательное для заполнения поле"),
  digitalCurrency: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  symbolCurrency: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
});

export const ModalCurrency = ({ modalShow, onClose, id, refresh = () => {} }) => {
  const dispatch = useDispatch();
  const { item, loadingItem, fetchedItem, deleted, error } = useSelector((state) => state.guides.currencies);

  const [isAddMode, setIsAddMode] = useStateIfMounted(true);
  const [deleteDialog, setDeleteDialog] = useStateIfMounted(false);

  // Основной эффект для определения режима
  useEffect(() => {
    if (!modalShow) return;
    
    const addMode = id == null || isNaN(id);
    setIsAddMode(addMode);
    
    // Если это режим добавления, сбрасываем форму
    if (addMode) {
      reset(defaultValues);
      clearErrors();
    }
  }, [modalShow, id]);

  const {
    control,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  const onSubmit = (data) => {
    return isAddMode ? dispatch(currencyActions.create(data)) : dispatch(currencyActions.update(item.id, data));
  };

  // Эффект для загрузки данных при редактировании
  useEffect(() => {
    if (!modalShow || isAddMode || !id) return;

    dispatch(currencyActions.getById(id));

    return () => dispatch({ type: "RESET_ITEM_CURRENCIES" });
  }, [modalShow, id, isAddMode]);

  // Эффект для заполнения формы при получении данных
  useEffect(() => {
    if (!fetchedItem || isAddMode || !modalShow) return;

    Object.keys(defaultValues).forEach((field) => setValue(field, item[field]));
  }, [item, fetchedItem, isAddMode, modalShow]);

  const handleDeleteClick = useCallback((id) => {
    dispatch(currencyActions.delete(id));
    setDeleteDialog(false);
  }, [dispatch, setDeleteDialog]);

  // Эффект для обработки успешного удаления
  useEffect(() => {
    if (deleted && modalShow) {
      setDeleteDialog(false);
      closeModalFunc();
      onClose();
      refresh();
      console.log('Валюта успешно удалена');
    }
  }, [deleted]);

  const closeModalFunc = () => {
    clearErrors();
    reset(defaultValues);
  };

  return (
    <div>
      <SimpleModal
        modalTitle={isAddMode ? "Новая валюта" : "Редактирование"}
        winPermissionName="Общие"
        modalShow={modalShow}
        modalSize="sm"
        fullScreen={false}
        loading={loadingItem}
        isAddMode={isAddMode}
        status={!isAddMode}
        operations={item}
        onSubmit={handleSubmit(onSubmit)}
        onClose={() => {
          onClose();
          closeModalFunc();
        }}
      >
        <form noValidate>
          <MyInput name="nameCurrency" control={control} label="Краткое наименование" required errors={errors?.nameCurrency} />
          <MyInput name="fullNameCurrency" control={control} label="Полное наименование" required errors={errors?.fullNameCurrency} />
          <MyInput name="digitalCurrency" control={control} label="Цифровой код" errors={errors?.digitalCurrency}/>
          <MyInput name="symbolCurrency" control={control} label="Буквенный код" errors={errors?.symbolCurrency}/>
          <MyCheckBox name="mainCurrency" control={control} label="Это валюта учета" />
          <div>
            <Button
              disabled={isAddMode}
              aria-describedby={id}
              size="small"
              color="primary"
              onClick={() => setDeleteDialog(true)}
              startIcon={<DeleteIcon />}
            >
              Удалить
            </Button>
          </div>
        </form>
      </SimpleModal>
      <DialogModal
        open={deleteDialog}
        onConfirmDialogClose={() => setDeleteDialog(false)}
        onYesClick={() => handleDeleteClick(item?.id)}
        text={`Вы действительно хотите удалить валюту - ${item?.nameCurrency}? Это действие невозможно отменить.`}
      />
    </div>
  );
};